var _path, _path2, _path3, _polygon, _polygon2, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBatches(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306.68,442.71v46.59c0,5.93-5.44,10.75-12.14,10.75H40.77c-6.71,0-12.14-4.81-12.14-10.75V158.07 c0-5.94,5.43-10.75,12.14-10.75h253.77c5.85,0,10.73,3.65,11.89,8.54v286.85H306.68z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M306.68,158.07v284.64h-0.25V155.87C306.59,156.57,306.68,157.32,306.68,158.07z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M391.7,82.1v331.23c0,5.94-5.44,10.75-12.14,10.75h-47.1v-294.6c0-3.28-3-5.93-6.7-5.93H113.65V82.1 c0-5.94,5.44-10.75,12.14-10.75h253.77C386.27,71.35,391.7,76.17,391.7,82.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "189.45,65.35 189.42,65.35 189.42,65.32  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "383.81,331.8 383.74,331.8 383.74,331.69  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M467.47,14.34v331.24c0,5.94-5.44,10.75-12.14,10.75h-37.35V53.37c0-3.28-3-5.93-6.7-5.93H189.42v-33.1 c0-5.94,5.44-10.75,12.14-10.75h253.77C462.04,3.59,467.47,8.41,467.47,14.34z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M306.68,158.07v284.64h-0.25V155.87C306.59,156.57,306.68,157.32,306.68,158.07z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M306.68,158.07v99.79l-0.25-0.35V155.87C306.59,156.57,306.68,157.32,306.68,158.07z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatches);
export default __webpack_public_path__ + "static/media/batches.01a81791.svg";
export { ForwardRef as ReactComponent };